export const admin = {
  // ダッシュボード共通
  dashboardTitle: '運営ダッシュボード',
  dashboardSubtitle: '管理機能の入口。すべて読み取り専用ビューです（更新は各個別画面で行います）。',
  adminBadge: 'Admin',
  loggedInAs: 'ログイン中',

  // 入口リンクカード
  linksTitle: '管理機能',
  matchingTitle: 'マッチング管理',
  matchingDesc: '希望リクエストのペアリングと確定',
  wordPoolTitle: 'Word Pool 承認',
  wordPoolDesc: '投稿単語の審査・公開、団体申請の承認',
  levelCheckTitle: 'レベルチェック結果',
  levelCheckDesc: '受験結果の一覧と合否の確認',
  open: '開く →',

  // タブ
  tabUsers: 'ユーザー',
  tabBilling: '課金状況',
  tabApplications: '団体申請',
  tabSignups: '集客名簿',

  // ユーザー一覧
  usersTitle: 'ユーザー一覧',
  usersSearchPlaceholder: '名前・メールで検索',
  colName: '名前',
  colEmail: 'メールアドレス',
  colNative: '母語',
  colTarget: '学習言語',
  colLevel: 'レベル',
  colOrg: '団体',
  colSubStatus: '課金',
  filterAll: 'すべて',
  filterMembers: '個人',
  filterOrg: '団体所属',
  subNone: '未登録',
  subActive: 'アクティブ',
  subPaused: '一時停止',
  subCancelled: '解約済み',
  noUsers: '該当するユーザーはいません',

  // 課金状況
  billingTitle: '課金状況',
  billingDesc: 'サブスクリプション契約中のユーザー一覧です。',
  colPlan: 'プラン',
  colRemaining: '残レッスン',
  colRollover: '繰越',
  colPeriodEnd: '次回更新',
  noBilling: '契約中のサブスクリプションはありません',

  // 団体申請
  applicationsTitle: '団体申請（審査待ち）',
  applicationsNote: 'ここは読み取り専用です。承認・却下は Word Pool 管理画面で実施してください。',
  colOrgName: '団体名',
  colType: '種別',
  colSchedulingMode: 'スケジュール',
  colApplicantUser: '申請者',
  colIdDocument: '身分証',
  colCreatedAt: '申請日時',
  hasIdDocument: 'あり',
  noIdDocument: 'なし',
  noApplications: '審査待ちの団体申請はありません',
  goToWordPoolApprove: 'Word Pool 管理で承認 →',

  // 集客名簿
  signupsTitle: '集客名簿（コミュニティ登録）',
  colSignupName: '名前',
  colOrganizationName: '団体名',
  colConsent: '掲載同意',
  colStatus: 'ステータス',
  consentYes: '同意あり',
  consentNo: 'なし',
  noSignups: '集客名簿のデータはありません',
  signupsUnavailable: '集客名簿テーブルは未設定か、アクセス権がありません。',

  // 無料モード（FREE_MODE）切替
  freeModeTitle: '無料モード（課金のON/OFF）',
  freeModeDesc: '無料モードがONの間は、プラン選択画面で課金導線を出さず、チェックアウトも作成しません（誤課金防止）。OFFにすると従来の有料プラン選択が有効になります。',
  freeModeCurrentLabel: '現在の状態',
  freeModeOn: '無料モード（課金OFF）',
  freeModeOff: '有料モード（課金ON）',
  freeModeTurnOff: '有料モードにする（課金を有効化）',
  freeModeTurnOn: '無料モードにする（課金を停止）',
  freeModeUpdating: '更新中...',
  freeModeUpdateError: '無料モードの更新に失敗しました。',
  freeModeLoadError: '無料モードの状態を取得できませんでした（既定: 無料）。',

  // マッチング: Google Meet 自動生成
  meetGenerateButton: 'Google Meet を自動生成',
  meetGenerating: '生成中...',
  meetGenerateSuccess: 'Google Meet リンクを生成しました。',
  meetFallbackNotice: '自動生成は無効です。手動で Meet リンクを入力してください。',
  meetGenerateError: 'Meet の自動生成に失敗しました。手動で Meet リンクを入力してください。',

  // 共通状態
  loading: '読み込み中...',
  loadError: 'データの取得に失敗しました。',
  showingCount: '{{count}} 件',

  // ── Word Pool 承認管理画面 (admin/word-pool) ──
  wordPoolAdmin: {
    statusPending: '承認待ち',
    statusApproved: '承認済み',
    statusRejected: '却下',
    heading: 'Word Pool 承認管理',
    adminLabel: 'Admin: ',
    toLevelCheck: 'レベルチェック結果 →',
    filterAll: 'すべて',
    empty: '該当する投稿はありません',
    lessonLabel: 'レッスン: ',
    commentPlaceholder: 'コメント（任意）',
    approve: '承認',
    reject: '却下',
    commentLabel: 'コメント: ',
  },

  // ── レベルチェック結果画面 (admin/level-check-results) ──
  levelCheckAdmin: {
    heading: 'レベルチェック結果',
    adminLabel: 'Admin: ',
    toWordPool: '← Word Pool管理',
    statTotal: '総受験数',
    statPassed: '合格',
    statFailed: '不合格',
    statAvgScore: '平均スコア',
    filterLanguage: '言語:',
    filterLevel: 'レベル:',
    filterPassed: '合否:',
    filterAll: 'すべて',
    levelPrefix: 'Lv.',
    levelLabel: 'Level',
    empty: '該当する結果はありません',
    passed: '合格',
    failed: '不合格',
    member: '会員',
    wrongQuestions: '不正解: 問題 {{questions}}',
    scoreUnit: '点',
  },

  // ── マッチング管理画面 (admin/matching) ──
  matching: {
    confirmSuccess: 'マッチングを確定しました！両ユーザーにメールを送信しました。',
    errorPrefix: 'エラー: ',
    heading: 'マッチング管理',
    adminLabel: 'Admin: ',
    toWordPool: 'Word Pool承認 →',
    toLevelCheck: 'レベルチェック結果 →',
    pairConfirm: 'ペア確定',
    compatibilityScore: '相性スコア',
    scoreLang: '言語',
    scoreTime: '時間帯',
    scoreTz: 'TZ差',
    breakdownLang: '① 言語一致（利害関係）',
    breakdownTime: '② 時間帯の重複',
    breakdownTz: '③ TZ差（参考）',
    langFull: '✅ 完全一致',
    langPartial: '⚠️ 片方のみ',
    langNone: '❌ 不一致',
    slotsOverlap: '{{count}} スロット重複',
    slotsNone: '重複なし',
    tzDiff: 'UTC差 {{hours}}時間',
    langScore: '{{score}} / 50点',
    timeScore: '{{score}} / 40点',
    tzScore: '{{score}} / 10点',
    choice: '第{{n}}希望：',
    meetLinkLabel: 'Google Meet リンク',
    worksheetLabel: 'ワークシート PDF URL',
    worksheetHint: '（任意 — 入力するとメールにリンクが追加されます）',
    worksheetHelper: 'Supabase Storage の worksheets バケットにPDFをアップロードして、公開URLを貼り付けてください',
    confirming: '確定中...',
    confirmPair: 'このペアで確定する',
    cancel: 'キャンセル',
    empty: '現在マッチング待ちのリクエストはありません',
    selectTwo: 'ペアにするユーザーを2人選択してください（現在 {{count}} 件のリクエスト）',
    nativeBadge: '母語: {{lang}}',
    learningBadge: '学習: {{lang}}',
    pointSuffix: '点',
    confirmedSlotLabel: '確定レッスン日時',
    confirmedSlotPlaceholder: '日時を選択（両者の共通希望を推奨）',
    slotOverlapSuffix: '（共通希望）',
    slotNoOverlapWarn: '⚠ 両者の共通希望時間がありません。手動選択時は相手の都合を確認してください。',
    selectSlotFirst: '確定レッスン日時を先に選択してください。',
    recommendTitle: 'おすすめペア',
    recommendDesc: '相性スコア順の自動ランキングです。「このペアを選ぶ」で確定パネルへ移動します。',
    selectThisPair: 'このペアを選ぶ',
    sharedSlotPrefix: '共通: ',
    noShared: '共通希望なし',
    noRecommend: 'おすすめ候補がありません',
    recommendScore: '相性 {{score}}/100',
  },
};
